import React from "react"
import ResellerHostingBlock from "../reseller/ResellerHostingBlock"

const ResellerBlock = () => {
  return (
      <section className="pricing text-start">
        <div className="container-xl">
          <h3 className="mb-4 component-title text-dark-blue">Reseller Hosting</h3>
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="description" >
                <p>
                  Motherhost offers reseller hosting services, allowing you to
                  kickstart your hosting business with ease. Customize your
                  hosting plans according to your preferences and manage your
                  customers effortlessly. With seamless integration options for
                  billing software and round-the-clock support, we ensure a
                  smooth experience for you and your clients.
                </p>

                <p>Key features of our reseller hosting package include:</p>

                <ol>
                  <li>
                    <strong>Flexible Hosting Plans</strong>: Define hosting
                    plans tailored to your target market and business goals.
                  </li>

                  <li>
                    <strong>Customer Management</strong>: Easily create and
                    manage customer accounts, ensuring a personalized and
                    efficient service.
                  </li>

                  <li>
                    <strong>Billing Software Integration</strong>: Seamlessly
                    integrate your preferred billing software for streamlined
                    invoicing and payment processing.
                  </li>

                  <li>
                    <strong>24/7 Support</strong>: Our dedicated support team is
                    available around the clock to assist you with any queries or
                    issues.
                  </li>

                  <li>
                    <strong>Free SSL Certificate</strong>: Secure all domains
                    under your hosting with free SSL certificates, enhancing
                    trust and security for your clients.
                  </li>

                  <li>
                    <strong>Free Domain Name Reseller Account</strong>: Gain
                    access to a domain name reseller account at no extra cost,
                    offering additional value to your clients.
                  </li>

                  <li>
                    <strong>100% White Label Control Panel</strong>: Customize
                    the control panel with your branding, ensuring a consistent
                    and professional image for your hosting business.
                  </li>
                </ol>

                <p>
                  With Motherhost's reseller hosting, you have the tools and
                  support you need to succeed in the hosting industry while
                  providing top-notch services to your clients.
                </p>
              </div>
            </div>
            <ResellerHostingBlock />
          </div>
        </div>
      </section>
  )
}

export default ResellerBlock
